import { FulfillmentCompanyById } from "../modules";

export const FulfillmentCompanyByIdPage = () => {
  return <FulfillmentCompanyById />;
};
